import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { LeafDivider } from '../ui/LeafDivider';
export function TheProblem() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-16 px-4 bg-white/50" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="prose prose-lg prose-headings:font-playfair prose-p:text-forest/80 max-w-none" data-id="element-118">
          <motion.div variants={itemVariants} className="bg-cream-200/50 p-8 md:p-12 rounded-3xl shadow-sm mb-16 relative overflow-hidden" data-id="element-119">
            <div className="absolute top-0 left-0 w-2 h-full bg-sage-400" data-id="element-120"></div>
            <p className="text-xl md:text-2xl font-playfair italic text-forest leading-relaxed mb-0" data-id="element-121">
              "Faltan dos días para tu evento. Te pruebas el vestido, subes el
              cierre y sientes esa presión familiar. No es grasa, es una
              inflamación rígida y dolorosa que parece haber aparecido de la
              noche a la mañana."
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="space-y-6" data-id="element-122">
            <p data-id="element-123">
              No importa cuántas abdominales hagas hoy; si tu cuerpo está en
              "modo alerta" por el cortisol, retendrá líquidos y aire sin
              importar qué comas. Necesitas una solución de salida rápida que
              funcione con la fisiología de tu cuerpo, no en su contra.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-6" data-id="element-124">
              La trampa de la "solución rápida"
            </h2>
            <p data-id="element-125">
              La mayoría de las mujeres intentan solucionar la hinchazón
              abdominal de último minuto con laxantes agresivos, fajas
              asfixiantes o dejando de comer por completo. El problema es que
              estas acciones disparan aún más el cortisol (la hormona del
              estrés), lo que le ordena a tu cuerpo retener cada gota de agua
              por protección.
            </p>
            <p className="font-semibold text-forest bg-sage-300/20 p-4 rounded-lg border-l-4 border-sage-500" data-id="element-126">
              Estás atrapada en un ciclo donde intentar "desinflamar" te inflama
              más. Tu abdomen se siente duro, tu digestión se detiene y la
              frustración arruina tu confianza antes de salir de casa.
            </p>
          </motion.div>

          <LeafDivider data-id="element-127" />

          <motion.div variants={itemVariants} className="mt-12" data-id="element-128">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-129">
              Por qué lo que has intentado no funcionó:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-130">
              {[{
              title: 'Diuréticos de farmacia',
              desc: 'Eliminan minerales esenciales, causando fatiga y un efecto rebote de hinchazón a las pocas horas.'
            }, {
              title: "Dietas 'detox' de jugos",
              desc: 'Añaden azúcares de golpe que fermentan en tu intestino, creando más gas del que eliminan.'
            }, {
              title: 'Cardio intenso',
              desc: 'Aumenta la inflamación sistémica justo cuando necesitas calma interna y reducir el cortisol.'
            }, {
              title: "Bebidas 'light'",
              desc: 'Los edulcorantes son identificados por tu colon como invasores, provocando distensión inmediata.'
            }].map((item, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-200 flex items-start space-x-4" data-id="element-131">
                  <div className="flex-shrink-0 mt-1" data-id="element-132">
                    <svg className="w-6 h-6 text-red-400/70" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-133">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-134" />
                    </svg>
                  </div>
                  <div data-id="element-135">
                    <h4 className="font-bold text-lg mb-1 mt-0" data-id="element-136">
                      {item.title}
                    </h4>
                    <p className="text-sm text-forest/70 m-0 leading-snug" data-id="element-137">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}